// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { NetworkSource } from "@lib/messaging/NetworkSource";

/**
 * Provides an API for sending a message object to a specific destination.
 */
export interface IMessageSender
{
  sendMessage(destination: NetworkSource, message: object): void;
}